module.exports = __webpack_public_path__ + "assets/img/120608.8d3f854c.svg";